import React from 'react';
import { connect } from 'react-redux';
import agent from '../agent'
import { Link } from 'react-router-dom';
import {
  HOME_PAGE_LOADED,
  HOME_PAGE_UNLOADED,
  ACCOUNT_LIST_EXPORT,
  CLEAR_PROPS
} from '../constants/actionTypes'
import { BASE_COIN_SYMBOL } from '../constants/config'
import numberHelper from '../util/numberFormatter'
const mapStateToProps = state => ({
  ...state.home,
  currentUser: state.common.currentUser,
  appName: state.common.appName,
  token: state.common.token,
  inProgress: state.common.inProgress
});

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: HOME_PAGE_LOADED, payload })
  },
  onUnload: () =>
    dispatch({ type: HOME_PAGE_UNLOADED }),
  onExportAccounts: (payload, symbol) =>
    dispatch({ type: ACCOUNT_LIST_EXPORT, payload, symbol }),
  clearProps: () =>
    dispatch({ type: CLEAR_PROPS }),
});

class Home extends React.Component {
  componentWillMount() {
    const payload = agent.Common.statistics()
    this.props.onLoad(payload);
  }

  componentWillUnmount() {
    this.props.onUnload();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.csvData) {
      var data = new Blob([nextProps.csvData], { type: 'text/csv' });
      var csvURL = window.URL.createObjectURL(data);
      var tempLink = document.createElement('a');
      document.body.appendChild(tempLink) // fix for FF
      tempLink.href = csvURL;
      tempLink.setAttribute('download', `${new Date()}_${nextProps.symbol}_accounts.csv`);
      tempLink.click();
      this.props.clearProps()
      document.body.removeChild(tempLink);
    }
  }
  exportAccounts = (symbol) => ev => {
    ev.preventDefault()
    const payload = agent.Accounts.exportAccounts(symbol)
    this.props.onExportAccounts(payload, symbol)
  }
  render() {
    const inProgress = this.props.inProgress

    if (!this.props.currentUser) {
      return (
        <div>
          <div className="notice">
            <Link className="button" to="/login">Please Log In</Link>
          </div>
        </div>
      )
    }

    return (
      (this.props.inProgress) ? (
        <div>
          <div className="broad">
            Loading...
            </div>
        </div>
      ) : (

              <div className='pane'>
                <h1>Admin Home</h1>
                <div className="infoGroupHome">
                  <div className="infoPairHome">
                    <label>Users:</label> <span>{this.props.user_count}</span>
                  </div>

                </div>
              </div>
            
        )
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js